import T from "./T";

const employeesTableHeader = (companyId: string, systemCode: string) => {
  const {
    COMPANY,
    EMPLOYEE_NAME,
    EMAIL,
    PAYROLL_ID,
    PAY_TYPE,
    SCHEDULE,
    BUSINESS_UNIT,
    STATUS,
    REGISTRATION_DATE,
    ACTION,
  } = T;

  const businessUnit: any = [];
  if (systemCode == T.ASTUTE.toUpperCase())
    businessUnit.push({ label: BUSINESS_UNIT });

  const tableFields = [
    { label: COMPANY },
    { label: EMPLOYEE_NAME },
    { label: EMAIL },
    { label: PAYROLL_ID },
    { label: PAY_TYPE },
    { label: SCHEDULE },
    ...businessUnit,
    { label: STATUS },
    { label: REGISTRATION_DATE },
    { label: ACTION },
  ];

  return tableFields;
};

export default employeesTableHeader;
